// extracted by mini-css-extract-plugin
module.exports = {"container":"F1z7z5","Tooltip":"RMmbQg","Tip":"mcCSl_","item":"_3Psbbt","title":"f9SKr_","message":"UW3CDN","clear":"_2Or0Pf"};